import React from 'react';

import { StyledArrow } from './Arrow.styles';

import { ArrowProps, DirectionalArrowProps } from './Arrow.types';

import { BackgroundImage } from '../../../../';

export const PreviousArrow = ({
  componentClassname,
  customClassnames,
  sliderDispatch,
  isHidden = false,
  children,
}: DirectionalArrowProps) => (
  <Arrow
    componentClassname={componentClassname}
    customClassnames={customClassnames}
    direction="prev"
    srOnlyText="Previous slides"
    isHidden={isHidden}
    sliderDispatch={sliderDispatch}
  >
    {children || (
      <BackgroundImage
        src={'https://images.playosmo.com/osmo-slider-arrow.svg'}
        style={{ backgroundSize: 'contain' }}
        className="icon"
      />
    )}
  </Arrow>
);

export const NextArrow = ({
  componentClassname,
  customClassnames,
  sliderDispatch,
  isHidden = false,
  children = null,
}: DirectionalArrowProps) => (
  <Arrow
    componentClassname={componentClassname}
    customClassnames={customClassnames}
    direction="next"
    srOnlyText="Next slides"
    isHidden={isHidden}
    sliderDispatch={sliderDispatch}
  >
    {children || (
      <BackgroundImage
        src={'https://images.playosmo.com/osmo-slider-arrow.svg'}
        style={{ backgroundSize: 'contain' }}
        className="icon"
      />
    )}
  </Arrow>
);

const Arrow = ({
  componentClassname = 'arrow',
  customClassnames = '',
  direction,
  srOnlyText,
  children,
  isHidden,
  sliderDispatch,
}: ArrowProps) => {
  return (
    <StyledArrow
      className={`${componentClassname} ${customClassnames} ${
        direction ? `${componentClassname}--${direction}-direction` : ''
      } ${isHidden ? `${componentClassname}--is-hidden` : ''}`}
      onClick={() =>
        sliderDispatch({ type: direction, payload: { source: 'arrow' } })
      }
    >
      <div aria-hidden="true">{children}</div>
      <span className="sr-only">{srOnlyText}</span>
    </StyledArrow>
  );
};
Arrow.displayName = 'Arrow';

export default Arrow;
